import { render, staticRenderFns } from "./ValidatableIdentityDictionarySelection.vue?vue&type=template&id=15bd1420&"
import script from "./ValidatableIdentityDictionarySelection.vue?vue&type=script&lang=js&"
export * from "./ValidatableIdentityDictionarySelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports